// Lightweight fetch + cache for static config files
// Caches in localStorage with a TTL to avoid frequent network calls.

const DEFAULT_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours

async function fetchJson(url) {
  const res = await fetch(url, { credentials: 'same-origin' });
  if (!res.ok) throw new Error(`Failed to load ${url}: ${res.status}`);
  return res.json();
}

function getCache(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.ts || !parsed.data) return null;
    return parsed;
  } catch (_) {
    return null;
  }
}

function setCache(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data }));
  } catch (_) {}
}

export async function fetchElementsIntroConfig(ttlMs = DEFAULT_TTL_MS) {
  const cacheKey = 'elements_intro_config_v2';
  const cached = getCache(cacheKey);
  if (cached && Date.now() - cached.ts < ttlMs) {
    return cached.data;
  }
  const remoteUrl = process.env.REACT_APP_ELEMENTS_INTRO_CONFIG_URL;
  const url = remoteUrl && remoteUrl.length > 0
    ? remoteUrl
    : `${process.env.PUBLIC_URL || ''}/static/config/elements_intro.json`;
  const data = await fetchJson(url);
  setCache(cacheKey, data);
  return data;
}
